import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";

import { InvoicesService } from "../shared/services/invoices.service";

@Injectable()
export class InvoiceResolver implements Resolve<any> {
  constructor(private service: InvoicesService) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any>|Promise<any>|any {
    return this.service.getInvoice(route.paramMap.get('id'));
  }
}



// WEBPACK FOOTER //
// /app/src/app/resolver/invoice.resolver.ts